import { NavLink, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Cars from '../../../components/editing/Cars';
import About from '../../../components/editing/AboutParagraphs';
import PhoneNumbers from '../../../components/editing/PhoneNumbers';
import Emails from '../../../components/editing/Emails';
import ServicePacks from '../../../components/editing/ServicePacks';
import Services from '../../../components/editing/Services';
import DynamicTable from '../../../components/editing/DynamicTable';
import IframeViewer from '../../../components/editing/IframeViewer';
import { useState } from 'react';
import './editingPage.css';

const BASE_API = process.env.REACT_APP_BACKEND_URL + '/api';
const BASE_WEB = process.env.REACT_APP_FRONTEND_URL;

const pageConfig = {
  'cars': {
    apiPath: '/cars',
    iframePath: '/cars',
    component: <Cars />,
  },
  'About': {
    apiPath: '/about',
    iframePath: '/about',
    component: <About />,
  },
  'phone numbers': {
    apiPath: '/phonenumbers',
    iframePath: '/contact',
    component: <PhoneNumbers />,
  },
  'emails': {
    apiPath: '/emails',
    iframePath: '/contact',
    component: <Emails />,
  },
  'service packs': {
    apiPath: '/services/packs',
    iframePath: '/services',
    component: <ServicePacks />,
  },
    'services': {
    apiPath: '/services/packs',
    iframePath: '/services',
    component: <Services />,
  },
};

const ContentRenderer = () => {
  const { subpage } = useParams();
  const config = pageConfig[subpage];
  const [refreshKey, setRefreshKey] = useState(0);

  if (!config) return <p>Invalid page</p>;

  var tableEndpoint = `${BASE_API}${config.apiPath}`;
  const iframeUrl = `${BASE_WEB}${config.iframePath}`;

  const handleRefreshAll = () => setRefreshKey((prev) => prev + 1);

  return (
    <>
      {config.component}

      <div className="refresh-all-container">
        <button className="refresh-all-btn" onClick={handleRefreshAll}>
          Refresh
        </button>
      </div>

      <DynamicTable endpoint={tableEndpoint} refreshKey={refreshKey} />
      <IframeViewer key={refreshKey} url={iframeUrl} title={'Web Viewer'} />
    </>
  );
};

const EditingPage = () => {
  return (
    <div className="editing-container">
      <header className="editing-topbar">
        <nav className="editing-nav">
          {Object.keys(pageConfig).map((key) => (
            <NavLink
              key={key}
              to={`/admin/edit-pages/${key}`}
              className={({ isActive }) =>
                `editing-link ${isActive ? 'active' : ''}`
              }
            >
              {key.replace('-', ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="editing-content">
        <Routes>
          <Route path="/" element={<Navigate to="/admin/edit-pages/cars" replace />} />
          <Route path=":subpage" element={<ContentRenderer />} />
        </Routes>
      </main>
    </div>
  );
};

export default EditingPage;
